import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { SignUpPage } from '@/features/auth/pages/sign-up-page/SignUpPage';

const RouteComponent = () => {
  return (
    <AuthLayout>
      <SignUpPage />
    </AuthLayout>
  );
};

export const Route = createFileRoute('/sign-up')({
  component: RouteComponent,
});
